<template>
  <div class="container py-3">
    <br>
    <div class="row">
      <div class="col-lg-8 col-xl-7">
        <h1 class="h3">Thank you!</h1>
        <p class="lead grey">Your booking request is now received.</p>
        <p>We'll reach out shortly to confirm price and availability. Stay tuned 👊</p>
        <hr>
        <p><small><router-link to="/trailers" class="blue">← Back to trailers</router-link></small></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    mounted() {
      this.$store.commit('meta/title', 'Thank you!')
    },
}
</script>
